import styled, { css } from 'styled-components';
import { mediaQueryWidth } from '../../common/breakpoints';
import { StyledInformationalPage } from '../../common/static.styles';

const outputResponsiveHeights = (height: number | { mobile: number; tablet: number; desktop: number }) =>
  typeof height === 'number'
    ? css`
        height: ${height}px;
      `
    : css`
        height: ${height.mobile}px;

        ${mediaQueryWidth({ min: 'tablet' })`
          height: ${height.tablet}px;
        `};

        ${mediaQueryWidth({ min: 'desktop' })`
          height: ${height.desktop}px;
        `};
      `;

export const StyledNewsletter = styled(StyledInformationalPage)<{
  collapsePadding?: boolean;
  iFrameHeight: number | { mobile: number; tablet: number; desktop: number };
}>`
  div.content {
    ${({ iFrameHeight }) => outputResponsiveHeights(iFrameHeight)};
    ${({ collapsePadding }) => collapsePadding && 'padding: 0 !important;'}
    padding-bottom: 0 !important;
  }

  #content {
    padding-bottom: 0 !important;
  }

  iframe {
    width: 100%;
    height: 100%;
    border: 0;
    display: none;
  }
`;

export const StyledNewsletterLoader = styled.div<{ isVisible: boolean }>`
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
  width: 100px;
  height: 100px;
  margin: 10rem auto;
  border: 8px solid #f3f3f3;
  border-top: 8px solid rgb(14, 14, 14);
  border-radius: 50%;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
